(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glacia-launch"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-glacia-countdown]').forEach((root) => {
      const end = new Date(root.dataset.preorderEnd).getTime();
      if (!Number.isFinite(end)) return;
      const days = root.querySelector('[data-days]');
      const hours = root.querySelector('[data-hours]');
      const minutes = root.querySelector('[data-minutes]');
      const label = root.querySelector('[data-countdown-label]');
      const render = () => {
        const remaining = Math.max(0, end - Date.now());
        const totalMinutes = Math.floor(remaining / 60000);
        days.textContent = String(Math.floor(totalMinutes / 1440)).padStart(2, '0');
        hours.textContent = String(Math.floor((totalMinutes % 1440) / 60)).padStart(2, '0');
        minutes.textContent = String(totalMinutes % 60).padStart(2, '0');
        if (remaining === 0) label.textContent = root.dataset.closedLabel || 'Pre-order window closed';
      };
      render();
      window.setInterval(render, 60000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
